export default "__VITE_ASSET__c5e5229c__"